export const SET_FINISH = "FINISHES_SET_FINISH";
export const RESET_FINISH = "FINISHES_RESET_FINISH";
export const RESET_FINISHES = "FINISHES_RESET_FINISHES";
export const SET_FINISHES = "FINISHES_SET_FINISHES";
export const SET_ERROR = "FINISHES_SET_ERROR";
export const CHANGE_ATTR = "FINISHES_CHANGE_ATTR";
export const TOGGLE_ACTIVE = "FINISHES_TOGGLE_ACTIVE";